import { get } from "lodash";
import format from "string-template";
import * as yup from "yup";
import { requiredIdentitySideSchema } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/identityDocuments";

const CIN_AGE_THRESHOLD = 18;

const validation = (messages, includedChildren = []) => {
  const schemaShape = {};
  includedChildren.forEach(({ userId, age, identity }) => {
    const requiredMessage = format(
      messages.REQUIRED_CHILD_ATTACHMENT || messages.REQUIRED_ATTACHMENT,
      {
        firstName: get(identity, "user.firstname", ""),
        lastName: get(identity, "user.lastname", ""),
      },
    );

    schemaShape[`socialSecurityCertificate_${userId}`] = yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(requiredMessage)
      .min(1, requiredMessage);

    if (age > CIN_AGE_THRESHOLD) {
      schemaShape[`cinRecto_${userId}`] = requiredIdentitySideSchema(messages);
      schemaShape[`cinVerso_${userId}`] = requiredIdentitySideSchema(messages);
    }

    schemaShape[`schoolCertificate_${userId}`] = yup.array().nullable();
  });

  return yup.object().shape(schemaShape);
};

export default validation;
